import React from "react";
import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/constants/testIds";

const testimonials = [
  {
    name: "Priya Kapoor",
    role: "Founder, Bloomwell Skincare",
    quote:
      "Akshay didn't just run ads — he rebuilt our whole funnel. In 4 months we went from break-even to 3.8x ROAS. He thinks like an owner.",
  },
  {
    name: "Rohit Mehta",
    role: "CEO, LeadStack (SaaS)",
    quote:
      "We tried two agencies before Akshay. He shipped more in 30 days than they did in 6 months. Organic leads are now our #1 channel.",
  },
  {
    name: "Dr. Anjali Rao",
    role: "Director, Veda Clinics",
    quote:
      "Our cost per lead dropped from ₹12 to ₹4 and the quality went up. Akshay is genuinely strategic — not just an executor.",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid={TESTIMONIALS.section}
      className="relative py-24 lg:py-40 bg-[#09090B] text-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 lg:mb-24">
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-block h-2 w-2 bg-white" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">
                Testimonials
              </span>
            </div>
            <p className="text-sm text-zinc-500">04 / 06</p>
          </div>
          <div className="lg:col-span-9">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              What clients
              <br />
              <span className="text-zinc-500">actually say.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-zinc-800">
          {testimonials.map((t, idx) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: idx * 0.08 }}
              className="bg-[#09090B] p-8 lg:p-10 flex flex-col"
            >
              <div className="font-display text-7xl leading-none text-[#002FA7]">&ldquo;</div>
              <blockquote className="mt-4 text-lg leading-relaxed text-zinc-200 flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-zinc-800">
                <div className="font-semibold text-white">{t.name}</div>
                <div className="text-xs text-zinc-500 uppercase tracking-widest mt-1">
                  {t.role}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
